import { API_BASE_URL, endpoints } from 'app/api/endpoints'
import { ChatMessageSend } from 'app/components/shared/Chat'
import { QuotationRequestMessage } from 'EstraSuppliers'
import { MapToChatMessageData } from '../mappers'

export const sendQuotationChatMessage = async (
  authToken: string,
  quotationId: number,
  chatMessage: ChatMessageSend,
  updateAuthToken?: (authToken: string | null) => void
) => {
  const apiURL = `${API_BASE_URL}/${endpoints.sendQuotationChatMessage(
    quotationId
  )}`

  // Build body based on type
  const body = new FormData()

  if (chatMessage.type === 'file') {
    if (chatMessage.file) body.append('file', chatMessage.file)
  } else if (chatMessage.type === 'text') {
    if (chatMessage.message) body.append('message', chatMessage.message)
  }
  body.append('type', chatMessage.type)
  body.append('sent_at', chatMessage.sent_at)

  return await fetch(apiURL, {
    method: 'POST',
    headers: {
      Authorization: authToken,
    },
    body: body,
  })
    .then(response =>
      response.json().then((json: QuotationRequestMessage) => {
        if (response.status === 200) {
          return MapToChatMessageData(json)
        } else {
          throw new Error(status.toString())
        }
      })
    )
    .catch(error => {
      if (error.message === '401') {
        if (updateAuthToken) updateAuthToken(null)
      }
      const errorMessage =
        error.message === '422'
          ? 'File o Formato del file non validi'
          : "Errore durante l'invio del messaggio."

      throw Error(errorMessage)
    })
}
